module.exports = __webpack_public_path__ + "static/img/bg-es.1c3c7c9b.png";